import { useParams } from "react-router-dom";

export const useParamId = () => {
  const params = useParams<{ id: string }>();
  if (!params.id) throw new Error("ID not found in URL params.");
  return params.id;
};
